export default "__VITE_ASSET__6ec80ce1__"